import React, { useCallback, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import styles from './styles.module.css';

/* Зелёная плашка снизу по центру: всплывает на две секунды и исчезает.
   Хук отдаёт функцию показа и текущее состояние; повторный вызов
   перезапускает отсчёт. */

const TOAST_MS = 2000;

export const useToast = () => {
  const [state, setState] = useState({ text: '', on: false });
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  const show = useCallback((text) => {
    clearTimeout(timer.current);
    setState({ text, on: true });
    timer.current = setTimeout(() => setState((prev) => ({ ...prev, on: false })), TOAST_MS);
  }, []);

  return [state, show];
};

const Toast = ({ text, on }) => createPortal(
  <div className={on ? styles.toastOn : styles.toast} role="status" aria-live="polite">{text}</div>,
  document.body
);

export default Toast;
